const principles = [
  { icon: "ri-clipboard-line", text: "尊重事实，只还原页面的客观留痕" },
  { icon: "ri-eye-off-line", text: "只读存档，不对原始页面做任何修改" },
  { icon: "ri-link-m", text: "保留出处，每条快照都可回溯来源与时间" },
  { icon: "ri-team-line", text: "人工复核，重大页面抽检避免误判" },
  { icon: "ri-shield-user-line", text: "严守边界，涉及隐私与违规内容不展示" },
  { icon: "ri-delete-back-2-line", text: "随删随退，尊重权利人下架诉求" },
];

const milestones = [
  { year: "2016", text: "开始提供网页快照留痕服务" },
  { year: "2019", text: "上线逐版本时间线与回溯查看" },
  { year: "2023", text: "推出缓存版本还原与监控队列" },
  { year: "2026", text: "快照对比高亮全面升级" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full scroll-mt-16 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,6fr)_minmax(0,5fr)]">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">ABOUT · 关于我们</p>
            <h2 className="mt-3 text-2xl leading-snug text-foreground-950 md:text-4xl">
              一家专注“内容留痕”与“历史追溯”的网页快照存档站
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-700 md:text-base">
              吃瓜网页历史快照定位于“让每一段被删改的公开内容都有据可查”。我们相信，信息在网络上发布后，
              其删改与下线过程本身就是值得被记录的公共事实。因此我们持续对公开页面进行只读快照、
              缓存版本与旧版存档的收录，帮助编辑、研究者与普通读者在需要时快速找回原始内容。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
              我们并不生产或演绎事件本身，只做忠实的时间切片：把页面在每一个时间点呈现的样子如实保存下来，
              再提供清晰的对比与时间线，让追溯者自己判断前后发生了什么。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.text} className="flex items-start gap-2.5 rounded-lg bg-background-50 p-3 text-sm leading-5 text-foreground-700 ring-1 ring-background-200">
                  <i className={`mt-0.5 text-lg ${p.icon} text-accent-700`}></i>
                  <span>{p.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20coral%20and%20cream%20editorial%20illustration%20of%20an%20open%20archive%20timeline%20with%20stacked%20document%20pages%20and%20a%20magnifying%20glass%2C%20soft%20leaf%20green%20accents%2C%20playful%20flat%20style%2C%20clean%20airy%20background%2C%20no%20text%2C%20no%20people&width=900&height=1100&seq=chigua-about-ill&orientation=portrait"
                alt="吃瓜网页历史快照的存档时间线插图"
                title="吃瓜网页历史快照存档时间线"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl border border-background-200 bg-background-50/95 px-5 py-4 backdrop-blur md:left-6">
              <div>
                <p className="font-heading text-2xl text-primary-600">10+</p>
                <p className="text-xs text-foreground-600">持续服务年限</p>
              </div>
              <div className="h-8 w-px bg-background-200"></div>
              <div>
                <p className="font-heading text-2xl text-accent-600">180+</p>
                <p className="text-xs text-foreground-600">复核协作伙伴</p>
              </div>
              <div className="h-8 w-px bg-background-200"></div>
              <div>
                <p className="font-heading text-2xl text-secondary-600">7×24</p>
                <p className="text-xs text-foreground-600">自动抓取运行</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 md:grid-cols-4 md:p-6">
          {milestones.map((m, i) => (
            <div key={m.year} className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                <i className="ri-time-line text-lg"></i>
              </span>
              <div>
                <p className="font-heading text-xl text-primary-600">{m.year}</p>
                <p className="mt-1 text-xs leading-5 text-foreground-700 md:text-sm">{m.text}</p>
              </div>
              {i < milestones.length - 1 && <span className="hidden flex-1 self-center border-t border-dashed border-background-300 md:block"></span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}